import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { environment } from './../../../../../environment/environment';
import { headerColumns } from './../../../../core/models/entreprise';
import { DatePipe } from '@angular/common';
import { Component, ElementRef } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import {
  blockSuccess,
  deblockSuccess,
  dejabloque,
  serverError,
} from './../../../../core/models/messages';
import { CompanyService } from './../../../../core/services/company/company.service';
import { EsnAppeloffreService } from './../../../../core/services/esn-appeloffre/esn-appeloffre.service';
import { SortDataService } from './../../../../core/services/sortdata';
import { Country } from 'country-state-city';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { translations } from '../../../../core/models/call-offer';

@Component({
  selector: 'app-liste-entreprise-clientfinal',
  templateUrl: './liste-entreprise-clientfinal.component.html',
  styleUrls: ['./liste-entreprise-clientfinal.component.css'],
})
export class ListeEntrepriseClientfinalComponent {
  isCollapsed = true; // Initial state
  private unsubscribeAll: Subject<void> = new Subject();
  /* any */
  file: any;
  selectedImage: any;
  /* modal */
  //  modalRef?: BsModalRef;
  /* object */
  responsableCompany: any;
  /* arrays */
  listCampany: any = [];
  dataHeader: any = [];
  listNames: string[] = [];
  typesCompanies = [
    { id: 1, name: 'Entreprise' },
    { id: 2, name: 'ESN' },
    { id: 3, name: 'Client Final' },
    { id: 4, name: 'Cabinet de Recrutement' },
  ];
  /* number */
  totalItems!: number;
  currentSortDirection: number = 2;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  typee:any
  startIndex: number = 0;
  endIndex: number = 5;
  headerColumns: { checked: boolean; name: string; code: string }[] =
    headerColumns;

  /* string */
  mode: string = 'create';
  isLoadSpinner: boolean = true;

  url: string = environment.baseUrl + '/api';
  urlimage: string = environment.baseUrlGalery;
  fileError: string = '';
  fileExtention: string = '';
  fileName: string = '';
  /* formGroup */
  loadSpinnerTable: boolean = false;
  pagination : boolean =false;

  loadSpinner: boolean = false;
  companyType = new FormControl();
  /* form data */
  formData = new FormData();
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  typeCompany = [
    { id: 2, name: 'ESN' },
    { id: 3, name: 'Client Final' },
    { id: 4, name: 'Cabinet de Recrutement' },
  ];
  currentSortColumn: string = 'name';

  /* unsubscription */

  searchForm: FormGroup = this.createSearchForm();
  pays = [
    { id: 1, name: 'France' },
    { id: 2, name: 'Tunisie' },
    { id: 3, name: 'Turquie' },
    { id: 4, name: 'Allemagne' },
  ];
  sortAttr = '';
  typeintervenant: any;
  idclientConnected: any;
  constructor(
    private companyService: CompanyService,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private appelOffreService: EsnAppeloffreService,
    private toastr: ToastrService,
    private router: Router,
    private datePipe: DatePipe,
    private sortdata: SortDataService,
    private localStorageService: LocalStorageService,
    private elRef: ElementRef,
  ) {}
  ngOnInit() {
    this.typeintervenant = this.localStorageService.getData('typeintervenant');
    this.getListCompanies();
    this.getListElementHeader();
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');
      const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
      scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
  }
  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');
    
    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
      console.log('HEYYYYYYYYYYYY');
    }
  }
  getListElementHeader() {
    if (!this.typeintervenant) {
      this.appelOffreService
        .getHeaderElementsentrepriseclienfinal(24)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.dataHeader = res.data;
            for (const iterator of this.dataHeader) {
              if (
                (iterator.checked == 'oui' && !iterator.checked_user) ||
                (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
                (iterator.checked == 'oui' && iterator.checked_user == 'oui')
              )
                this.listNames.push(iterator.name);
            }
            this.dataHeader.map((el: any) => {
              if (
                (el.checked == 'oui' && !el.checked_user) ||
                (el.checked_user == 'oui' &&
                  (el.checked == 'non' || el.checked == 'oui'))
              ) {
                return (el.checkAdmin = true);
              } else {
                return (el.checkAdmin = false);
              }
            });
          },
          error: () => {},
        });
    }
   
  }

  changeSelection(event: any, data: any, i: number) {
    this.listNames = [];
    data.checkAdmin = event.target.checked;
    for (const iterator of this.dataHeader) {
      if (iterator.checkAdmin) this.listNames.push(iterator.name);
    }
    this.changeSelectionHeadrElements(data);
  }
  changeSelectionHeadrElements(data: any) {
    if (!this.typeintervenant) {
      let payload = {
        sub_page_id: data?.id,
      };
      this.companyService
        .changeDelectedElementcfHeader(payload)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {},
          error: () => {},
        });
    } else {
      let payload = {
        sub_page_id: data?.id,
      };
      this.companyService
        .changeSubPageStateIntervenant(payload)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {},
          error: () => {},
        });
    }
  }
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }

  /* get indexes for pagination */
  getItems(event?: any) {
    console.log('evnet', event);

    if (
      (event && event.startIndex != this.startIndex) ||
      this.endIndex != event.endIndex ||
      this.itemsPerPage != event.itemsPerPage ||
      this.currentPage != event.currentPage
    ) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
      if (this.searchForm.dirty) {
        this.searchCompnies();
      } else if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){        this.pagination = true
        this.getListCompanies();
      }
    }
  }
  handleRatingClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.classList.contains('bs-rating-star')) {
      // Check if the "active" class is present
      const isActive = target.classList.contains('active');
      // Toggle the "active" class
      target.classList.toggle('active', !isActive);
    }
  }

  // sortData(item:string){
  //   this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
  //   this.sortAttr=item
  //   console.log("form",this.searchForm.value)
  //   if (this.searchForm.dirty) this.listCampany = this.sortdata.sortArray(this.listCampany,  this.sortAttr, this.currentSortDirection)
  //    this.getListCompanies()

  // }
  sortData(item: string) {
    console.log('item', item);
    for (const iterator of headerColumns) {
      if (item == iterator.name) item = iterator.code;
    }
    this.sortAttr = item;
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    this.currentPage = 1;
    this.endIndex = 5;
    if (this.searchForm.dirty)
      this.listCampany = this.sortdata.sortArray(
        this.listCampany,
        item,
        this.currentSortDirection
      );
    else this.getListCompanies();
  }

  /* list list esn companies */
  getListCompanies() {
    this.spinner.show();
    let dataPyload =
      this.sortAttr == ''
        ? { per_page: this.itemsPerPage, page: this.currentPage, type: 2 }
        : {
            ...{ per_page: this.itemsPerPage, page: this.currentPage },
            ...{
              sort: this.currentSortDirection,
              sortAttribute: this.sortAttr,
            },
          };
    this.companyService
      .listCompany(dataPyload)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.isLoadSpinner = false;
          this.spinner.hide();
          this.listCampany = res.data.data
          this.typee=res.data.data.type  
          console.log('typee', this.typee);
                // .slice(0, this.endIndex);
          console.log('list company', this.listCampany);
          this.totalItems = res.data.total;
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }

  //////////////////////////////date de creation pour afficher dans la liste ///////////////////////////////////////////////////////////////////////////////////////////////////////////////

  formatDate(dateString: string | null): string {
    if (!dateString) {
      return '';
    }

    const date = new Date(dateString);
    return this.datePipe.transform(date, 'yyyy-MM-dd') || '';
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  uploadFile(event: any) {
    this.file = event.target.files[0];
    const maxSize = 2 * 1024 * 1024;
    this.fileName = this.file.name;
    if (this.file) {
      const allowedExtensions = ['.pdf'];
      const fileExtension = this.file.name
        .toLowerCase()
        .substr(this.file.name.lastIndexOf('.'));
      if (!allowedExtensions.includes(fileExtension)) {
        this.fileExtention = 'Format fichier non compatible !';
      } else if (this.file.size > maxSize) {
        this.fileError = 'Le fichier à importer ne doit pas depasser 2 méga !';
      } else {
        this.fileError = '';
        this.fileExtention = '';
      }
    }
    // this.addCandidateFormGroup.markAsDirty();
  }

  translateCountryName(name: string): string {
   
    return translations[name] || name;
  }

  bloquer(idCompany: any) {
    Swal.fire({
      title: " Vous êtes sûr de bloquer l'entreprise sélectionnée ? ",
      icon: 'warning',
      iconColor: '#ff0000',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, bloquer',
      cancelButtonText: 'Annuler', // Changer le texte du bouton Cancel ici
    }).then((result) => {
      if (result.isConfirmed) {
        console.log(
          '%centreprises.component.ts line:212 idCompany+++',
          'color: #007acc;',
          idCompany
        );

        this.blockCompany(idCompany);
        this.getListCompanies();
      }
    });
  }
  debloquer(idCompany: any) {
    Swal.fire({
      title: " Vous êtes sûr de débloquer l'entreprise sélectionnée ? ",
      icon: 'warning',
      iconColor: '#ff0000',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'oui, débloquer',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.deblockCompany(idCompany);
        this.getListCompanies();
      }
    });
  }
  /* deblock  company */
  deblockCompany(idCompany: any) {
    this.spinner.show();
    this.companyService
      .deblockCompany(idCompany)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.toastr.success(deblockSuccess);
          this.getListCompanies();
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error(serverError);
        },
      });
  }

  /* block  company */
  blockCompany(idCompany: any) {
    this.spinner.show();
    console.log(
      '%centreprises.component.ts line:221 idCompany',
      'color: #007acc;',
      idCompany
    );
    this.companyService
      .blockCompany(idCompany)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.toastr.success(blockSuccess);
          this.getListCompanies();
        },
        error: () => {
          this.toastr.error(dejabloque);
        },
      });
  }

  /* search */
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      ID_company: [data ? data.ID_company : ''],
      name: [data ? data.name : ''],
      typeComp: [data ? data.typeComp : null],
      country: [data ? data.country : null],
      note: [data ? data.note : ''],
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
    });
  }

  searchCompnies() {
    let data = {
      name: this.searchForm.value?.name,
      typeComp: !this.searchForm.value.typeComp
        ? ''
        : this.searchForm.value.typeComp.toString(),
      country: !this.searchForm.value.country
        ? []
        : this.searchForm.value.country,
      note: this.searchForm.value.note,
      ID_company: this.searchForm.value.ID_company,
      page: this.currentPage,
      per_page: this.itemsPerPage,
      search: this.transformSearch(this.searchForm.value?.search),
    };
    this.spinner.show();
    this.companyService
      .searchCompany(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if ( this.currentPage > 1) {
            this.currentPage = 1;
            this.searchCompnies();
          } else {
            this.listCampany = res.data.data.slice(0, this.endIndex);
            this.totalItems = res.data.total;
            this.spinner.hide();
          }
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    search = search.replace(/\s+/g, ' ');

    return search.trim();
  }
  reset() {
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.searchCompnies();
  }

  /* ************************* navigation contact responsable ********************* */
  contactResponsableNavigation(id: any) {
    this.router.navigate(['/contact', { idResponsable: id }]);
  }

  /* ************************* navigation contact responsable ********************* */
  VoiroffreNavigation(id: any) {
    this.router.navigate(['/entreprises/offre-entreprise', { id: id }]);
  }
  /* ************************* navigation offre  ********************* */
  profilCompanyNavigation(id: any) {
    this.router.navigate([
      '/entreprises/details-entreprise',
      { id: id },
    ]);
  }

  /* ************************* navigation contact responsable ********************* */
  reviewCompanyNavigation(id: any) {
    this.router.navigate(['/evaluer-esn', { id: id }]);
  }
}
